import * as React from 'react';


export const useToggle = (
  initialValue: boolean = false,
): [boolean, () => unknown] => {
  const [isToggled, setToggleValue] = React.useState(initialValue);
  const toggleValue = () => setToggleValue((prev) => !prev);

  return [isToggled, toggleValue];
};
